import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface DeleteWordRequest {
    word_idx: number[];
}

export const useDeleteWord = (successCallback?: () => void): UseMutationResult<null, Error, DeleteWordRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, DeleteWordRequest>({
        mutationFn: async (deleteData: DeleteWordRequest) => {
            const response = await axios.request({
                method: "DELETE",
                url: `${enum_api_uri.delete_word}`,
                data: deleteData,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getWordList"] });
            successCallback?.();
        },
    });
};
